import { create } from "zustand";
import type { OrganizationUser } from "../types";

interface OrgUsersState {
	modalOpen: boolean;
	editingItem: OrganizationUser | null;
}

interface OrgUsersActions {
	openCreateModal: () => void;
	openEditModal: (item: OrganizationUser) => void;
	closeModal: () => void;
}

type OrgUsersStore = OrgUsersState & OrgUsersActions;

export const useOrgUsersStore = create<OrgUsersStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingItem: null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null });
	},
}));
